import { useDispatch, useSelector } from "react-redux";
import { getXMLValidation } from "../../../../actions/connectivity";
import { StyledXML } from "../../../styled/xml";
import XmlValidationForm from "./xmlValidationForm";

const xmlTypeOptions = [
    { nombre: "IET", id: "Evolucion" },
    { nombre: "IAMI", id: "Ingreso" },
    { nombre: "AM", id: "Alta" },
    { nombre: "FPA", id: "Autorizacion" },
    { nombre: "FPT", id: "Traslado" },
    { nombre: "TURNO", id: "Turno" }
]

const XmlValidationContainer = () => {
    const dispatch = useDispatch();
    const xmlValidations = useSelector(state => state.connectivity.xmlValidations);

    const handleValidateXML = (xmlType, xmlCode) => {
        if (xmlType && xmlCode) {
            dispatch(getXMLValidation(xmlCode, xmlType));
        }
    }

    return <div>
        <StyledXML.Title>Validación de XML</StyledXML.Title>
        <XmlValidationForm
            validations={xmlValidations}
            xmlTypeOptions={xmlTypeOptions}
            handleValidateXML={handleValidateXML}
        />
    </div>
};

export default XmlValidationContainer;